export const createValidator = (value: any) => {
  const errors: any = {};
  console.log("value", value);

  if (!value.name) {
    errors.name = "Required";
  }
  if (!value.measurementUnit) {
    errors.measurementUnit = "Required";
  }
  if (!value.categories) {
    errors.categories = "At least 1 category required";
  }
  if (!value.retail) {
    errors.retail = "Required";
  }
  if (!value.wholeSale) {
    errors.wholeSale = "Required";
  }
  
  return errors;
};

export const createMassCommoditiesValidator = (values: any) => {
  const errors: any = {};
  if (!values.commodities || !values.commodities.length) {
    errors.commodities = { _error: "At least one member must be entered" };
  } else {
    const commoditiesError: any[] = [];
    values.commodities.forEach((commodity: any, commodityIndex: number) => {
      const commodityError: any = {};

      if (!commodity || !commodity.name) {
        commodityError.name = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.measurementUnit) {
        commodityError.measurementUnit = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.categories) {
        commodityError.categories = "At least 1 category required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.retail) {
        commodityError.retail = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      if (!commodity || !commodity.wholeSale) {
        commodityError.wholeSale = "Required";
        commoditiesError[commodityIndex] = commodityError;
      }

      // if (!commodity || !commodity.retailPrice) {
      //   commodityError.retailPrice = "Required";
      //   commoditiesError[commodityIndex] = commodityError;
      // }
    });

    if (commoditiesError.length) {
      errors.commodities = commoditiesError;
    }
  }
  return errors;
};
